import React from "react";
import { Instagram } from "lucide-react";
import WhatsAppButton from "@/components/WhatsAppButton";

const INSTAGRAM_URL = "https://instagram.com/freetourtorrevieja";
const TRIPADVISOR_URL = "https://www.tripadvisor.es/Attraction_Review-g187527-d34618931-Reviews-Free_Tour_Torrevieja-Torrevieja_Costa_Blanca_Province_of_Alicante_Valencian_Comm.html";

const base = "flex items-center justify-center w-11 h-11 sm:w-14 sm:h-14 rounded-full hover:scale-110 transition-transform duration-200";

const SocialButtons = () => (
  <div className="fixed bottom-5 left-5 z-50 flex flex-col gap-3" data-testid="social-buttons">
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
      data-testid="instagram-button"
      className={`${base} bg-[radial-gradient(circle_at_30%_110%,#fdf497_0%,#fd5949_45%,#d6249f_60%,#285AEB_90%)] shadow-[0_6px_20px_rgba(214,36,159,0.45)]`}
    >
      <Instagram color="#fff" size={24} />
    </a>
    <a
      href={TRIPADVISOR_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Tripadvisor"
      data-testid="tripadvisor-button"
      className={`${base} bg-[#34E0A1] shadow-[0_6px_20px_rgba(52,224,161,0.5)]`}
    >
      <svg viewBox="0 0 24 24" width="32" height="32" fill="#000" aria-hidden="true">
        <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.963 2.135a5.997 5.997 0 0 0 4.04 10.43 5.976 5.976 0 0 0 4.075-1.6L12 19.705l1.922-2.09a5.972 5.972 0 0 0 4.072 1.598 6 6 0 0 0 6-5.998 5.982 5.982 0 0 0-1.957-4.432L24 6.648h-4.35a13.573 13.573 0 0 0-7.644-2.353zM12 6.255c1.531 0 3.063.303 4.504.903C13.943 8.138 12 10.43 12 13.1c0-2.671-1.942-4.962-4.504-5.942A11.72 11.72 0 0 1 12 6.256zM6.002 9.157a4.059 4.059 0 1 1 0 8.118 4.059 4.059 0 0 1 0-8.118zm11.992.002a4.057 4.057 0 1 1 .003 8.115 4.057 4.057 0 0 1-.003-8.115zm-11.992 1.93a2.128 2.128 0 0 0 0 4.256 2.128 2.128 0 0 0 0-4.256zm11.992 0a2.128 2.128 0 0 0 0 4.256 2.128 2.128 0 0 0 0-4.256z" />
      </svg>
    </a>
    <WhatsAppButton />
  </div>
);

export default SocialButtons;
